var map = {
	"assets/bgImages/riwisBg01": 91924,
	"assets/bgImages/riwisBg02": 37987,
	"assets/bgImages/riwisBg03": 47878,
	"assets/bgImages/riwisBg04": 64077,
	"assets/bgImages/riwisBg05": 19184,
	"assets/bgImages/riwisBg06": 8940,
	"assets/bgImages/riwisBg07": 94850,
	"assets/bgImages/riwisBg08": 29337,
	"assets/bgImages/riwisBg09": 58812,
	"assets/bgImages/riwisBg10": 36890,
	"assets/bgImages/riwisBg11": 5175,
	"assets/bgImages/riwisBg12": 66504,
	"assets/bgImages/riwisBg13": 94117,
	"assets/bgImages/riwisBg14": 51230,
	"assets/bgImages/riwisBg15": 71387,
	"assets/bgImages/riwisBg16": 44940,
	"assets/bgImages/riwisBg17": 42729,
	"assets/bgImages/riwisBg18": 60018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2372;